// src/pages/Appli/AppliAdmin/users-admin/utils/usersAdmin.utils.js

import {
  DEFAULT_ROLE_META,
  ROLE_META,
} from "../data/usersAdmin.data";

export const normalize = (value = "") =>
  value
    .toString()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();

export const formatDateFR = (date) => {
  if (!date) return "—";

  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) {
    return "—";
  }

  return parsedDate.toLocaleDateString("fr-FR");
};

export const getRoleMeta = (roleId) =>
  ROLE_META[Number(roleId)] || DEFAULT_ROLE_META;

export const groupBadgesByUser = (badges = []) => {
  const result = {};

  badges.forEach((badge) => {
    const userId = badge?.user_id;

    if (!userId) return;

    if (!result[userId]) {
      result[userId] = [];
    }

    result[userId].push(badge);
  });

  Object.keys(result).forEach((userId) => {
    result[userId].sort(
      (firstBadge, secondBadge) =>
        new Date(secondBadge?.validation_date || 0).getTime() -
        new Date(firstBadge?.validation_date || 0).getTime(),
    );
  });

  return result;
};

export const extractClubs = (user) => {
  if (Array.isArray(user?.Clubs)) {
    return user.Clubs.filter(Boolean);
  }

  if (Array.isArray(user?.clubs)) {
    return user.clubs.filter(Boolean);
  }

  if (Array.isArray(user?.UserClubs)) {
    return user.UserClubs.map(
      (userClub) => userClub?.Club || userClub,
    ).filter(Boolean);
  }

  if (user?.Club) {
    return [user.Club];
  }

  return [];
};

export const extractActeurs = (user) => {
  let acteurs = [];

  if (Array.isArray(user?.Acteurs)) {
    acteurs = user.Acteurs.filter(Boolean);
  } else if (Array.isArray(user?.acteurs)) {
    acteurs = user.acteurs.filter(Boolean);
  } else if (Array.isArray(user?.UserActeurs)) {
    acteurs = user.UserActeurs.map(
      (userActeur) => userActeur?.Acteur || userActeur,
    ).filter(Boolean);
  } else if (user?.Acteur) {
    acteurs = [user.Acteur];
  }

  return acteurs.sort((firstActeur, secondActeur) =>
    normalize(
      `${firstActeur?.nom || ""} ${firstActeur?.prenom || ""}`,
    ).localeCompare(
      normalize(
        `${secondActeur?.nom || ""} ${secondActeur?.prenom || ""}`,
      ),
      "fr",
    ),
  );
};

export const getCreatedTime = (user) => {
  const date = user?.createdOn || user?.createdAt || user?.created_at;
  const time = date ? new Date(date).getTime() : NaN;

  return Number.isFinite(time) ? time : 0;
};

export const addClubToUserLocally = (user, club) => {
  if (!user || !club) return user;

  const clubs = extractClubs(user);

  const alreadyLinked = clubs.some(
    (currentClub) => String(currentClub?.id) === String(club?.id),
  );

  if (alreadyLinked) return user;

  if (Array.isArray(user.Clubs)) {
    return {
      ...user,
      Clubs: [...user.Clubs, club],
    };
  }

  if (Array.isArray(user.clubs)) {
    return {
      ...user,
      clubs: [...user.clubs, club],
    };
  }

  if (Array.isArray(user.UserClubs)) {
    return {
      ...user,
      UserClubs: [...user.UserClubs, club],
    };
  }

  return {
    ...user,
    Clubs: [club],
  };
};

export const uniq = (values = []) =>
  [...new Set(values.filter(Boolean))];

export const slugifyFilePart = (value = "") =>
  normalize(value)
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const getExcelColumnLetter = (columnNumber) => {
  let result = "";
  let number = columnNumber;

  while (number > 0) {
    const modulo = (number - 1) % 26;

    result = String.fromCharCode(65 + modulo) + result;
    number = Math.floor((number - 1) / 26);
  }

  return result;
};